import { createFileRoute } from "@tanstack/react-router";

import ApiDocsAdmin from "@/components/ApiDocsAdmin";

// Generated to match `src/app/admin/api-docs/page.tsx`. The route is a passthrough: the console
// component owns everything, and `admin/route.tsx` owns the shell and the gate.
export const Route = createFileRoute("/admin/api-docs")({
  component: ApiDocsAdmin,
});
